import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown, Icon, type IDropdownItem, Label } from 'shared/ui'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { sameWidth } from 'shared/lib'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type RingFirstDropdownStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/Ring/ui/RingActionEditContent/RingFirstDropdown/store/RingFirstDropdownStore'

export const RingFirstDropdown = observer(({ store }: { store: RingFirstDropdownStore }) => {
  const { activeItem, setValue, items } = store
  const { integrationsStore } = useEntitiesContext()

  const onChange = (item: IDropdownItem, parent?: IDropdownItem) => {
    if (item.id === 'hubspot' && hubspot?.disconnected) {
      window.open('/settings/integrations/hubspot/description', '_blank')
    } else {
      setValue(parent ? `${parent.id}.${item.id}` : `${item.id}`)
    }
  }

  const hubspot = integrationsStore.getIntegration('hubspot')

  const dropdownItems: IDropdownItem[] = useMemo(() => {
    return items.map((item) => {
      if (item.id === 'hubspot' && hubspot?.disconnected) {
        return {
          ...item,
          labelContent: (
            <div className={'row8'}>
              HubsPot <Icon icon={'alertTriangleYellow'} />
            </div>
          ),
          iconR: undefined,
          labelRight: 'Reconnect',
          children: [],
        }
      }
      return item
    })
  }, [hubspot])

  return (
    <div>
      <Label
        label={{
          text: 'Ring first',
        }}
        marginBottom={4}
      />
      <Dropdown
        width={'100%'}
        onChange={onChange}
        PopperProps={{
          modifiers: [
            sameWidth(),
            {
              name: 'offset',
              options: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                offset: ({ reference }) => {
                  return [0, -reference.height - 8]
                },
              },
            },
          ],
        }}
        childContainerWidth={250}
        items={dropdownItems}
        triggerComponent={() => (
          <TextFieldPlaceholder
            variant='stroke'
            size='medium'
            leftActions={[makeTextFieldIcon({ icon: activeItem?.iconL })]}
            rightActions={[makeTextFieldIcon({ icon: 'chevronDown' })]}
            placeholder={activeItem?.label}
          />
        )}
      />
    </div>
  )
})
